import { issue__EventType } from "@medbillai/generated-graphql-types";

import { type RankableAction, rankHeadlineAction } from "./headlineAction";

// Short imperative copy naming the chosen action for a blocked case (ordering is
// owned by rankHeadlineAction; this only labels the headline). Unlisted types
// fall back to the generic prompt.
const HEADLINE_ACTION_LABEL: Partial<Record<issue__EventType, string>> = {
  [issue__EventType.HIPAA_RELEASE_REQUESTED]: "Sign consent form",
  [issue__EventType.TEMPLATE_RELEASE_REQUESTED]: "Sign consent form",
  [issue__EventType.CONNECT_INSURANCE_REQUESTED]: "Connect your insurance",
  [issue__EventType.CONNECT_ACCOUNT_REQUESTED]: "Connect your account",
  [issue__EventType.DOCUMENT_UPLOADED]: "Review your documents",
  [issue__EventType.PAYMENT_AGREEMENT_REQUESTED]: "Review payment agreement",
  [issue__EventType.BILL_PAY_REQUESTED]: "Review bill pay agreement",
  [issue__EventType.BILL_PAYMENT_REQUESTED]: "Pay your bill",
  [issue__EventType.CLOSURE_PAYMENT_REQUESTED]: "Make a payment",
  [issue__EventType.PAYMENT_CHARGE_FAILED]: "Update payment",
  [issue__EventType.CHAT]: "Respond to your case",
};

export const GENERIC_ACTION_LABEL = "Respond to your case";

/** Imperative label for a case's highest-priority required action. */
export function attentionActionLabel(caseItem: {
  actions?: readonly RankableAction[] | null;
}): string {
  const { headline } = rankHeadlineAction(caseItem.actions ?? []);
  return headline
    ? (HEADLINE_ACTION_LABEL[headline.eventType] ?? GENERIC_ACTION_LABEL)
    : GENERIC_ACTION_LABEL;
}
